<template>
  <!-- Page data offered by name. The stored value is still the path the site
       reads (`product.category_id`); it is shown underneath the name so it
       stays recognisable to whoever set the block up before. -->
  <v-select
    append-to-body
    :calculate-position="dropdownBelowField"
    :model-value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="options"
    label="label"
    :reduce="(v) => v.value"
    :placeholder="placeholder"
  >
    <!-- The name, and nothing else. The path the option writes is what the
         site reads, not what the person choosing needs to see: next to a
         wrapped name it collided with it, and it never told anyone which
         option to pick. It stays on the row as a tooltip. -->
    <template v-slot:option="option">
      <span class="var-label" :title="option.hint">{{ option.label }}</span>
    </template>
    <template v-slot:selected-option="option">
      <span class="var-label">{{ option.label }}</span>
    </template>
    <template v-slot:no-options> This page has no data to read from. </template>
  </v-select>
</template>

<script>
import { dropdownBelowField } from "../modules/select-position";

export default {
  name: "VariablePicker",
  props: {
    options: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    placeholder: { type: String, default: "Select data from the page" },
  },
  emits: ["update:modelValue"],
  methods: { dropdownBelowField },
};
</script>

<style scoped>
.var-label {
  font-size: 13px;
  font-weight: 700;
}
</style>
